// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-tooltip {
    background-color: #4d5760;
    text-align: left;
    width: 200px;
    height: 78px;
    padding: 16px;
    border-radius: 8px;
    box-sizing: border-box;
    color: #d6d9e0;
  }
  
  .chart-tooltip-balance {
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
  }
  
  .chart-bold {
    font-weight: bold;
    color: #ffffff;
    padding-left: 4px;
  }
  
  .chart-tooltip-date {
    font-size: 12px;
    line-height: 18px;
    margin-bottom: 5px;
  }`, "",{"version":3,"sources":["webpack://./src/features/appointments/components/chartStyle.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kBAAkB;EACpB","sourcesContent":[".chart-tooltip {\n    background-color: #4d5760;\n    text-align: left;\n    width: 200px;\n    height: 78px;\n    padding: 16px;\n    border-radius: 8px;\n    box-sizing: border-box;\n    color: #d6d9e0;\n  }\n  \n  .chart-tooltip-balance {\n    font-size: 14px;\n    line-height: 16px;\n    display: flex;\n    align-items: center;\n  }\n  \n  .chart-bold {\n    font-weight: bold;\n    color: #ffffff;\n    padding-left: 4px;\n  }\n  \n  .chart-tooltip-date {\n    font-size: 12px;\n    line-height: 18px;\n    margin-bottom: 5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
